"use client";
import { signIn } from "next-auth/react";
export default function Login() {
  return (
    <button
      className="min-w-auto px-4 bg-blue-800 p-2 rounded-xl hover:bg-blue-900 transition-colors ease-out text-white font-semibold"
      onClick={() => signIn("keycloak", { callbackUrl: "/register" })}
    >
      Login
    </button>
  );
}
